import React, { useState } from 'react';
import referralImage from '../assets/referralimage.png';
import ReferralModal from './ReferralModal';

const FloatingIPhoneParts: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {/* ── Referral card ── */}
      <div
        className="relative overflow-hidden rounded-2xl mb-6 cursor-pointer"
        style={{
          background: 'linear-gradient(120deg, #2d1260 0%, #7c3aed 60%, #c026d3 100%)',
          minHeight: '180px',
        }}
        onClick={() => setShowModal(true)}
      >
        {/* Image: full bleed */}
        <div className="absolute inset-0">
          <img
            src={referralImage}
            alt="Refer a friend"
            className="w-full h-full object-cover"
            style={{ objectPosition: '-100% center' }}
          />
          {/* Gradient: covers left, fades to transparent */}
          <div
            className="absolute inset-0"
            style={{
              background: 'linear-gradient(to right, #2d1260 0%, #3b1a7a 25%, rgba(76,29,149,0.85) 42%, rgba(76,29,149,0.3) 55%, transparent 70%)',
            }}
          />
        </div>

        {/* Left text */}
        <div className="relative z-10 flex flex-col justify-center h-full p-4" style={{ maxWidth: '52%', minHeight: '180px' }}>
          <div className="flex items-center gap-1.5 mb-2">
            <div className="w-1.5 h-1.5 rounded-full bg-yellow-300 animate-pulse flex-shrink-0" />
            <span className="text-yellow-300 text-[9px] font-bold tracking-wider uppercase whitespace-nowrap">Referral Offer</span>
          </div>

          <h2 className="text-white font-extrabold leading-tight mb-2" style={{ fontSize: '1.1rem' }}>
            Refer a Friend,<br />
            <span style={{ color: '#fbbf24' }}>Earn ₹100!</span>
          </h2>

          <p className="text-purple-200 mb-3 leading-snug" style={{ fontSize: '11px' }}>
            Friend gets <span className="text-white font-semibold">₹150 off</span> their first repair
          </p>

          <div
            className="inline-flex items-center gap-1.5 text-white font-bold whitespace-nowrap self-start shadow-lg"
            style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)', fontSize: '11px', padding: '7px 14px', borderRadius: '999px' }}
          >
            <i className="fas fa-gift" style={{ fontSize: '10px' }} />
            Get My Code
          </div>
        </div>
      </div>

      {showModal && <ReferralModal onClose={() => setShowModal(false)} />}
    </>
  );
};

export default FloatingIPhoneParts;
